import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './KeyValueSection.css';
import DataElementContainer from '../presenters/DataElementContainer';
import { dbXrefToLink } from '../support/Helpers';

// TODO: 
// - add linker support for dbxrefs

KeyValueSection.propTypes = {
  className: PropTypes.string,
  data:  PropTypes.object,
  label: PropTypes.string,
  closed: PropTypes.bool,
  helpPath: PropTypes.string,
}

KeyValueSection.defaultProps = {
  closed: false,
  data: {},
  label: 'Data',
}

function KeyValueSection(props) {
  const {
    className,
    data, 
    label,
    closed,
  } = props;

  const elementClass = classNames(
    'KeyValueSection', className
  );

  if (!data) {
    return null;
  }

  // Only dealing with top level for now
  const count = Object.keys(data).length;
  const dbXrefCount = Array.isArray(data.db_xref) ? data.db_xref.length : (data.db_xref ? 1 : 0);
  const fullLabel = (
    <div className='space-between'>
      <div>{label}:<span className='count'>{count}</span></div>
      { dbXrefCount > 0 ? <div style={{marginRight: '15px'}}>(db_xrefs:<span className='count'>{dbXrefCount}</span>)</div> : null }
    </div>
  );


  // console.log(data)
  function formatValueByKey(key, value) {
    // Add any specific formatting logic here based on key
    if (key === 'db_xref') {
      // If not an array make it an array
      if (!Array.isArray(value)) { value = [value]; }
      return value.map((id) => {
        const dbXref = dbXrefToLink(id);
        if (!dbXref.url) {
          return <span key={id}>{id}</span>;
        } else {
          return <a key={id} href={dbXref.url} target="_blank" rel="noopener noreferrer">{id}</a>;
        }
      }).reduce((prev, curr, idx) => [prev, ', ', curr]); 
    }
    // Otherwise just return the value as is
    return value;
  }

  return (
    <DataElementContainer className={elementClass} label={fullLabel} closable={true} closed={closed}
    // helpPath={helpPath}
    >
      <dl className='KeyValueSection'>
        {(() => {
          const entries = Object.entries(data);
          const dbXrefEntry = entries.find(([key]) => key === 'db_xref');
          const otherEntries = entries.filter(([key]) => key !== 'db_xref');
          const orderedEntries = dbXrefEntry ? [dbXrefEntry, ...otherEntries] : otherEntries;
          if (orderedEntries.length === 0) {
            return <div className='muted center'>No {label} Available</div>;
          }
          return orderedEntries.map(([key, value]) => (
            <div className='KeyValueItem' key={key}>
              <span className='KeyValueItemKey'>{key}</span>
              <span className='KeyValueItemValue'>{formatValueByKey(key, value)}</span>
            </div>
          ));
        })()}
      </dl>
    </DataElementContainer>
  );
}
export default KeyValueSection;
